import React, { useEffect, useState } from "react";
import { Field, change } from "redux-form";
import {
  renderTextField,
  renderOptionField,
  renderTextFieldPreValue,
} from "../formcomponents";
import { Table, Button } from "semantic-ui-react";

const WorkFieldArr = ({
  fields,
  props,
  setshowBtn,
  totalAmount,
  itemCategory,
  meta: { touched, error, submitFailed },
  formState,
}) => {
  const purchaseOrSale = [
    { text: "Purchase", value: 1 },
    { text: "Sale", value: 2 },
  ];
  const [total, setTotal] = useState([]);
  const [finalAmount, setFinalAmount] = useState([]);
  const [unitPrice, setUnitPrice] = useState([]);
  const [quantity, setQuantity] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [discountPer, setDiscountPer] = useState([]);

  const calculateTotal = (index, label, value) => {
    if (label === "quantity") {
      setQuantity((prevQuantity) => {
        const newQuantity = [...prevQuantity];
        newQuantity[index] = value;
        return newQuantity;
      });
    } else if (label === "unitPrice") {
      setUnitPrice((prevUnitPrice) => {
        const newUnitPrice = [...prevUnitPrice];
        newUnitPrice[index] = value;
        return newUnitPrice;
      });
    } else if (label === "discount") {
      setDiscount((prevDiscount) => {
        const newDiscount = [...prevDiscount];
        newDiscount[index] = value;
        return newDiscount;
      });
      setDiscountPer((prevDiscountPer) => {
        const newDiscountPer = [...prevDiscountPer];
        const amount = total[index] || 0;
        const discountPercentage = (value / amount) * 100;
        newDiscountPer[index] = discountPercentage;
        return newDiscountPer;
      });
    } else if (label === "discountPer") {
      setDiscountPer((prevDiscountPer) => {
        const newDiscountPer = [...prevDiscountPer];
        newDiscountPer[index] = value;
        return newDiscountPer;
      });

      setDiscount((prevDiscount) => {
        const newDiscount = [...prevDiscount];
        const amount = total[index] || 0;
        const discountAmount = (value / 100) * amount;
        newDiscount[index] = discountAmount;
        return newDiscount;
      });
    }
  };

  const [grandTotal, setGrandTotal] = useState(0);

  useEffect(() => {
    const tempTotal = quantity.map((qty, index) => {
      const price = unitPrice[index] || 0;
      return qty * price;
    });

    const calculatedFinalAmount = tempTotal.map((amount, index) => {
      const disc = discount[index] || 0;
      return amount - disc;
    });

    setTotal(tempTotal.map((value) => Number(value.toFixed(2))));
    setFinalAmount(
      calculatedFinalAmount.map((value) => Number(value.toFixed(2)))
    );

    const sum = calculatedFinalAmount.reduce((acc, curr) => acc + curr, 0);
    // setGrandTotal(Number(sum.toFixed(2)));
  }, [quantity, unitPrice, discount, discountPer]);

  const calculateGrandTotal = () => {
    return finalAmount.reduce((acc, val) => acc + val, 0).toFixed(2);
  };

  const sumQuantity = () =>
    quantity.reduce((acc, val) => acc + (parseFloat(val) || 0), 0).toFixed(2);

  const sumUnitPrice = () =>
    unitPrice.reduce((acc, val) => acc + (parseFloat(val) || 0), 0).toFixed(2);

  return (
    <>
      {/* <p>{itemCategory}</p> */}
      {fields.map((item, index) => (
        <Table.Row key={index}>
          <Table.Cell className="two wide">
            <Field
              name={`${item}.item`}
              type="text"
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="two wide">
            <Field
              name={`${item}.description`}
              type="text"
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="two wide">
            <Field
              name={`${item}.category`}
              type="text"
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="three wide">
            <Field
              name={`${item}.remarks`}
              type="text"
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="two wide">
            <Field
              name={`${item}.amount`}
              type="text"
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="one wide">
            <Field
              name={`${item}.quantity`}
              type="text"
              onChange={(e) =>
                calculateTotal(index, "quantity", e.target.value)
              }
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="one wide">
            <Field
              name={`${item}.unitPrice`}
              type="text"
              onChange={(e) =>
                calculateTotal(index, "unitPrice", e.target.value)
              }
              component={renderTextField}
            />
          </Table.Cell>
          <Table.Cell className="two wide">
            <Field
              name={`${item}.finalAmount`}
              type="text"
              fieldValue={finalAmount[index] || 0}
              component={renderTextFieldPreValue}
            />
          </Table.Cell>
          <Table.Cell className="one wide">
            <Button
              type="button"
              floated="left"
              negative
              onClick={() => fields.remove(index)}
            >
              X
            </Button>
          </Table.Cell>
        </Table.Row>
      ))}{" "}
      <br />
      <br />
      <Button
        type="button"
        positive
        floated="left"
        onClick={() => fields.push({})}
      >
        Add More
      </Button>
      <Table.Row>
        <Table.Cell className="two wide"></Table.Cell>
        <Table.Cell className="two wide"></Table.Cell>
        <Table.Cell className="two wide"></Table.Cell>
        <Table.Cell className="three wide"></Table.Cell>
        <Table.Cell className="two wide">
          <h3>Total</h3>
        </Table.Cell>
        <Table.Cell className="one wide">
          {sumQuantity()}
        </Table.Cell>
        <Table.Cell className="one wide"></Table.Cell>
        <Table.Cell className="one wide">{sumUnitPrice()}</Table.Cell>
        <Table.Cell className="two wide">
          {totalAmount ? totalAmount : calculateGrandTotal()}
        </Table.Cell>
        <Table.Cell className="one wide"></Table.Cell>
      </Table.Row>
    </>
  );
};

export default WorkFieldArr;
